module.exports = __webpack_public_path__ + "media/images/samples/home/ig2-efa653a5855481eb768ba33fad791c3b.png";